import React from 'react';
import styled from 'styled-components';
import Accordion from '../../UI/Accordion';
import parse from 'html-react-parser';
import { useSelector } from 'react-redux';
import { selectDrawerFaq } from '@/store/cms/faq/selectors';

const StyledFAQ = styled.section`
  padding: 32px 16px;
  max-width: 800px;
  margin: 0 auto;
  position: relative;

  @media (min-width: ${props => props.theme.breakpoints.small}) {
    padding: 32px;
  }

  h2.h3 {
    font-size: 24px;
    margin-bottom: 24px;

    @media (min-width: ${props => props.theme.breakpoints.small}) {
      font-size: 26px;
    }
  }

  .accordion-group {
    margin-bottom: 64px;
  }
`;

function HelpContent() {
  const faqDrawer = useSelector(selectDrawerFaq);

  return (
    <StyledFAQ>
      {faqDrawer.map((faq, index) => (
        <div key={`faq-drawer-${index}`}>
          <h2 className="h3">{faq.title}</h2>
          <div className="accordion-group">
            {faq.faqItems.map((faqItem, index) => (
              <Accordion
                key={`faq-question-drawer-${faqItem.question}-${index}`}
                header={faqItem.question}
              >
                <div className="prose prose-a:underline [&_a]:underline [&_a]:text-blue-600">
                  {parse(faqItem.answer)}
                </div>
              </Accordion>
            ))}
          </div>
        </div>
      ))}
    </StyledFAQ>
  );
}

export default HelpContent;
